import React from 'react';

import Text from 'components/Text/Text';
import { PersonTileCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './PersonTile.styles';

const PersonTile: React.FunctionComponent<PersonTileCMS> = ({
  image,
  title,
  subtitle,
  overlay,
}) => {
  const isOverlay = Boolean(overlay?.url.length);

  return (
    <S.PersonTileWrapper>
      <S.ImageWrapper>
        {isOverlay ? (
          <>
            <S.Image
              className="person_image"
              src={image.url}
              alt={image.alternativeText}
            />
            <S.Image
              className="person_image__overlay"
              src={overlay?.url || '/images/defaultLeaderOverlay.png'}
              alt={overlay?.alternativeText}
              overlay
            />
          </>
        ) : (
          <S.Image src={image.url} alt={image.alternativeText} overlay />
        )}
      </S.ImageWrapper>
      <Text text={title} size="smallBody" />
      <Text text={subtitle} size="smallBody" />
    </S.PersonTileWrapper>
  );
};

export default PersonTile;
